<template>
<div class="details">
  <b-card no-body v-if="loaded">
    <b-tabs @input="changedTab" small card>
      <b-tab :title="detail.title" :key="detail.field" v-for="detail in tables">
        <statistics-grid v-if="detail.visible" gridHeight="400px" :ref="'statsGrid' + detail.query.subrows" v-bind:query="detail.query" :name="'detailGrid' + detail" v-bind:url="url" v-bind:columns="detail.columns" :pageable='true' :filterable='true' :sortable='true'
          v-bind:schemaModelFields="detail.schemaModelFields" v-bind:schemaModelId="'id'" :aggregateDefinition="detail.aggregateDefinition" :rows="masterRows" :details="detail.details" v-bind:preload="preload"></statistics-grid>
          <div class="splash" v-if="!detail.visible">
            <div class="container  d-flex h-100">
              <div class="row justify-content-center text-primary w-100 align-self-center text-white">
                <i class="fa fa-spin fa-spinner"></i>
              </div>
            </div>
          </div>
      </b-tab>
    </b-tabs>
  </b-card>
</div>
</template>

<script>
import kendo from '@progress/kendo-ui/js/kendo.all.js'
export default {
  name: 'Detail',
  props: ['query', 'rowData', 'details', 'masterRows'],
  data() {
    return {
      preload: [],
      schemaModelFields: {},
      url: 'sellin',
      columns: [],
      aggregateDefinition: [],
      loaded: false,
      tableInitialized: false,
      tables: []
    }
  },
  methods: {
    changedTab(a) {
      this.axios.post('sellin/columns', this.tables[a].query).then(response => {
        var data = response.data.data
        this.tables[a].columns = data.columns
        this.tables[a].aggregateDefinition = data.aggregates
        this.tables[a].schemaModelFields = data.fields
        this.tables[a].visible = true
      })
    },
    seQueryFromRow(e) {
      e.preventDefault()
      var t = e.currentTarget
      var q = kendo.jQuery(t).data('query')
      var gridref = kendo.jQuery(t).data('gridref')
      var field = kendo.jQuery(t).data('field')
      var grid = this.$refs[gridref][0].$refs.mygrid.kendoWidget()
      var row = kendo.jQuery(t).closest('tr')
      var dataItem = grid.dataItem(row)
      q.filters = this.addFilter(q.filters, field, dataItem[field])
      console.log(q)
      this.$emit('filter-detail', {
        item: q
      })
    },
    addFilter(filters, field, value) {
      var found = false
      for (var c = 0; c < filters.length; c++) {
        if (filters[c].field === field) {
          filters[c].includes = [{
            id: value,
            name: 'auto'
          }]
          found = true
        }
      }
      if (!found) {
        filters.push({
          field: field,
          title: '',
          includes: [{
            id: value,
            name: 'auto'
          }],
          excludes: []
        })
      }
      return filters
    }
  },
  created() {
    var that = this
    // var loaders = []
    for (var i = 0; i < this.details.length; i++) {
      var d = this.details[i]
      for (var w = 0; w < d.subrows.length; w++) {
        var subs = d.subrows

        var q = JSON.parse(JSON.stringify(this.query))
        var groupby = q.groupby
        q.groupby = 'none'

        var id = this.rowData[this.query.subrows]

        q.filters = this.addFilter(q.filters, this.query.subrows, id)
        if (groupby !== 'none') {
          var groupById = this.rowData[groupby]
          q.filters = this.addFilter(q.filters, groupby, groupById)
        }

        q.rows = d.rows
        q.subrows = subs[w]
        this.tables.push({
          visible: false,
          title: this.masterRows[q.rows].sub[q.subrows].text,
          details: this.masterRows[q.rows].sub[q.subrows].details,
          field: q.subrows,
          query: q
        })

        // loaders.push(this.axios.post('statistics/columns', q))
      }
    }
    console.log('details', this.details)
    console.log('tables', this.tables)
    that.loaded = true
    // this.axios.all(loaders).then(
    //   that.axios.spread(function() {
    //     for (var i = 0; i < loaders.length; i++) {
    //       var data = arguments[i].data.data
    //       that.tables[i].columns = data.columns
    //       // that.tables[i].columns.push({
    //       //   'title': '',
    //       //   width: '120px',
    //       //   command: {
    //       //     name: 'pivot',
    //       //     template: '<a href class="btn btn-success  k-grid-pivot" data-field="' + that.tables[i].query.subrows + '" data-query=\'' + JSON.stringify(that.tables[i].query) + '\' data-gridref="statsGrid' + that.tables[i].query.subrows +
    //       //       '"><i class="fa fa-code-branch"></i></a>',
    //       //     click: that.seQueryFromRow
    //       //   }
    //       // })
    //       that.tables[i].aggregateDefinition = data.aggregates
    //       that.tables[i].schemaModelFields = data.fields
    //     }
    //     that.loaded = true
    //   })
    // ).catch(response => {
    //   console.error('error loading foreigns', response)
    // })
  }
}
</script>



// WEBPACK FOOTER //
// Detail.vue?9f0b0c02